import { render, staticRenderFns } from "./AgeTechService.vue?vue&type=template&id=53cf8cee"
import script from "./AgeTechService.vue?vue&type=script&lang=js"
export * from "./AgeTechService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports